import React, { useEffect, useState } from 'react'
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSelector } from 'react-redux';
import DatePicker from '../../../General/DatePicker';
import isNull from '../../../../utils/NullChecking';
import { enumUtil } from '../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../utils/NotificationHandler';
import Loader from '../../../shared/Loader/Loader';
import { format } from 'date-fns';
import handleNumericCheck from '../../../../utils/HandleNumericKeys';
import ModalFooter from '../../Shared/ModalFooter';
import { FindSecondChild } from '../../../../utils/FindMenuOption';
import AddNewCounty from './AddNewCounty';
import Modal from 'react-bootstrap/Modal';
import isAmountNull from '../../../../utils/AmountNullChecker';
import { ModalBody } from 'react-bootstrap';
import SearchList from '../../../Scheduler/Settings/SearchList';
const FeeSetup = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Insurance', 'Insurance')?.IsAdd
    let FeeSchedule_Modal = {
        ProviderFeeScheduleID: '',
        LocationID: '',
        InsuranceID: '',
        Amount: '',
        StartDate: '',
        EndDate: '',
        RevenueCode: '',
        RevenueCodeID: ''
    }
    const FeeSetupFilters = [
        { display: 'All', value: 'All' },
        { display: 'Active', value: 'Active' },
        { display: 'InActive', value: 'InActive' },
        { display: 'Expired', value: 'Expired' },
    ]
    const [selectedFilter, setSelectedFilter] = useState('Active')
    const { InsuranceID, mainInsuranceModal, onClose } = { ...props }
    const providersReducer = useSelector((state) => { return state?.GeneralDropDownsReducer });
    const API_URL = enumUtil.controller.ProviderFeeSchedule
    const API_URL_General = enumUtil.controller.General
    const [countyDD, setCountyDD] = useState([])
    const [selectedCounties, setselectedCounties] = useState([])
    const [FeeScheduleData, setFeeScheduleData] = useState([])
    const [FeeScheduleSave, setFeeScheduleSave] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [selectedLocation, setselectedLocation] = useState('')
    const [selectedLocationID, setselectedLocationID] = useState('')
    const [is, setIs] = useState(false);
    const [billingEntityOption, setBillingEntityOption] = useState([])
    const [feeSetupId, setfeeSetupid] = useState('0')
    const fetchData = async (isUpdated) => {
        if (!isNull(InsuranceID)) {
            setIs(true);
            setIsLoading(true);

            try {
                // Wait for LoadProgrameTypeDD to complete and get the response
                const programDD = await LoadProgrameTypeDD(isUpdated);

                // Proceed with FindProviderFeeSchedule after LoadProgrameTypeDD has resolved
                const response = await ServerRequestProtected(API_URL + "/FindProviderFeeSchedule", 'post', {
                    "TableName": enumUtil.enumAPITableName.AgencyProviderFeeSchedule,
                    "ID": InsuranceID + ""
                });

                if (isUpdated !== 'updated') {
                    if (response.length > 0) {
                        setselectedLocation(response[0].display);
                        setselectedLocationID(response[0].value);
                    }
                    let countylist = [];
                    response.map((item) => {
                        if (item.LocationID === response[0].value) {
                            item.ProgramTypes?.map((proItem) => {
                                if (proItem.ProgramType === programDD[1].value) {
                                    proItem.Counties?.map((countyitem) => {
                                        countylist.push({
                                            value: countyitem.FeeSetupCountyID,
                                            display: countyitem.County
                                        });
                                    });
                                }
                            });
                        }
                    });
                    setCountyDD(countylist);
                }
                let data2 = response;
                let RecordID = 0;
                data2.map((item) => {
                    item.ProgramTypes?.map((proType) => {
                        proType.Counties?.map((countyitem) => {
                            countyitem.OtherDetails?.map((othersitem) => {
                                RecordID += 1;
                                othersitem['RecordID'] = RecordID;
                                if (!isNull(othersitem.BillingEntity)) {
                                    othersitem['BillingEntityDisplay'] = othersitem.BillingEntity + "" === '1' ? 'Visit' :
                                        othersitem.BillingEntity + "" === '2' ? 'Hourly' :
                                            othersitem.BillingEntity + "" === '3' ? 'Daily' : ''
                                }
                            });
                        });
                    });
                });
                setFeeScheduleData(data2);

            } catch (error) {
                setFeeScheduleData([]);
                NotificationHandler(error.response?.data, enumUtil.enumtoaster.error);
            } finally {
                setIsLoading(false);
            }
        }
        GetBillingDropDown();
    };
    useEffect(() => {
        fetchData();
    }, [])
    // useEffect(() => {
    //     fetchData();
    // }, [feeSetupId])
    const GetBillingDropDown = () => {
        ServerRequestProtected(API_URL_General + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.BillingEntity
        }).then((response) => {
            setBillingEntityOption(response)
        }).catch((error) => {
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }
    const locationsList = providersReducer?.Location?.filter((item) => {
        return item?.value !== -1;
    });
    const handleCalendarChange = (date, name, index, proIndex, countiesIndex, recordid) => {
        var FormatedDate = date
        console.log(date, FormatedDate);

        let updatedData = [...FeeScheduleData]
        let otherindex
        let countyindex
        updatedData.map((item) => {
            item.ProgramTypes.map((proType) => {
                if (proType.ProgramType === ProgramTypeId) {
                    proType.Counties.map((countyitem, cindex) => {
                        countyitem.OtherDetails.map((otheritem, index) => {
                            if (otheritem.RecordID === recordid) {
                                otherindex = index
                                countyindex = cindex
                            }
                        })
                    })
                }
            })
        })
        updatedData[index].ProgramTypes[proIndex].Counties[countyindex].OtherDetails[otherindex][name] = FormatedDate
        setFeeScheduleData(updatedData)
        // handleSaveChange(updatedData, index, countiesIndex, otherindex, name, FormatedDate);
    }

    const [RevCodeBody, setRevCodeBody] = useState({ "TableName": enumUtil.enumAPITableName.RevenueCode, "SearchParam": '' })
    const handleChangeOtherDetails = (e, index, proIndex, countiesIndex, recordid) => {
        setIs(false);
        let { name, value } = e.target
        let updatedData = [...FeeScheduleData]
        let otherindex
        let countyindex
        updatedData.map((item) => {
            item.ProgramTypes.map((proType) => {
                if (proType.ProgramType === ProgramTypeId) {
                    proType.Counties.map((countyitem, cindex) => {
                        countyitem.OtherDetails.map((otheritem, index) => {
                            if (otheritem.RecordID === recordid) {
                                countyindex = cindex
                                otherindex = index
                            }
                        })
                    })
                }
            })
        })
        if (name === 'BillingEntity' && value === '2') {
            updatedData[index].ProgramTypes[proIndex].Counties[countyindex].OtherDetails[otherindex]['DefaultUnits'] = ''

        }
        updatedData[index].ProgramTypes[proIndex].Counties[countyindex].OtherDetails[otherindex][name] = value

        setFeeScheduleData(updatedData)
        if (name === 'RevenueCode') {
            setRevCodeBody({ "TableName": enumUtil.enumAPITableName.RevenueCode, "SearchParam": value })
        }
        // handleSaveChange(updatedData, index, countiesIndex, otherindex, name, value);
    }
    const AddNewCountyRow = (index, proIndex, countiesIndex, recordid) => {
        let updatedData = [...FeeScheduleData]
        let otherindex
        let countyindex
        updatedData.map((item) => {
            item.ProgramTypes.map((proType) => {
                if (proType.ProgramType === ProgramTypeId) {
                    proType.Counties.map((countyitem, cindex) => {
                        countyitem.OtherDetails.map((otheritem, index) => {
                            if (otheritem.RecordID === recordid) {
                                if (otheritem.isAdded) {
                                    NotificationHandler('cannot add more row against this CPT', enumUtil.enumtoaster.warning)
                                } else {
                                    otheritem.isAdded = true
                                    let newotheritem = {
                                        FeeSetupCountyID: otheritem.FeeSetupCountyID,
                                        ProcedureCode: otheritem.ProcedureCode,
                                        ProcedureCodeID: otheritem.ProcedureCodeID,
                                        ProgramType: otheritem.ProgramType,
                                        Status: otheritem.Status,
                                        countyname: otheritem.countyname,
                                        locationid: otheritem.locationid,
                                        ProviderFeeScheduleID: "0",
                                        RevenueCode: "",
                                        RevenueCodeID: "",
                                        StartDate: "",
                                        AllowedAmount: "",
                                        Amount: "",
                                        BillingEntity: "",
                                        DefaultUnits: "",
                                        EndDate: "",

                                    }
                                    let newOtherItem = { ...newotheritem };
                                    countyitem.OtherDetails.push(newOtherItem);

                                }

                            }
                        })
                    })
                }
            })
        })


        let RecordID = 0;
        updatedData.map((item) => {
            item.ProgramTypes?.map((proType) => {
                proType.Counties?.map((countyitem) => {
                    countyitem.OtherDetails?.map((othersitem) => {
                        RecordID += 1;
                        othersitem['RecordID'] = RecordID;
                    });
                });
            });
        });
        setFeeScheduleData(updatedData)
    }
    const handleSaveChange = (updatedData, index, countiesIndex, otherindex, field, value) => {
        const updatedSaveData = [...FeeScheduleSave];
        const detail = updatedData[index].Counties[countiesIndex].OtherDetails[otherindex];
        const existingEntryIndex = updatedSaveData.findIndex(item => item.ProviderFeeScheduleID === detail.ProviderFeeScheduleID);

        const newEntry = {
            ProviderFeeScheduleID: detail.ProviderFeeScheduleID,
            LocationID: updatedData[index].LocationID,
            InsuranceID: InsuranceID,
            ProcedureCode: detail.ProcedureCode,
            Amount: detail.Amount,
            StartDate: detail.StartDate,
            EndDate: detail.EndDate,
        };

        if (existingEntryIndex !== -1) {
            // Update the existing entry
            updatedSaveData[existingEntryIndex] = { ...updatedSaveData[existingEntryIndex], [field]: value };
        } else {
            // Add new entry
            updatedSaveData.push(newEntry);
        }
        setFeeScheduleSave(updatedSaveData)
    }
    const handleSelectRevenueCode = (singlerow, name, type, index, proIndex, countiesIndex, recordid) => {
        setIs(true)
        let updatedData = [...FeeScheduleData]
        let otherindex
        let countyindex
        updatedData.map((item) => {
            item.ProgramTypes.map((proType) => {
                if (proType.ProgramType === ProgramTypeId) {
                    proType.Counties.map((countyitem, cindex) => {
                        countyitem.OtherDetails.map((otheritem, index) => {
                            if (otheritem.RecordID === recordid) {
                                otherindex = index
                                countyindex = cindex
                            }
                        })
                    })
                }
            })
        })
        if (name === 'BillingEntity') {
            if (!isNull(singlerow)) {
                updatedData[index].ProgramTypes[proIndex].Counties[countyindex].OtherDetails[otherindex]['BillingEntityDisplay'] = singlerow.display + ""
                updatedData[index].ProgramTypes[proIndex].Counties[countyindex].OtherDetails[otherindex][name] = singlerow.value + ""

            } else {
                updatedData[index].ProgramTypes[proIndex].Counties[countyindex].OtherDetails[otherindex][name] = ""
                updatedData[index].ProgramTypes[proIndex].Counties[countyindex].OtherDetails[otherindex]['BillingEntityDisplay'] = ""

                // updatedData[index].ProgramTypes[proIndex].Counties[countyindex].OtherDetails[otherindex]['RevenueCodeID'] = ""
            }
        } else {
            if (!isNull(singlerow)) {
                updatedData[index].ProgramTypes[proIndex].Counties[countyindex].OtherDetails[otherindex][name] = singlerow.code + ""
                updatedData[index].ProgramTypes[proIndex].Counties[countyindex].OtherDetails[otherindex]['RevenueCodeID'] = singlerow.value + ""
            } else {
                updatedData[index].ProgramTypes[proIndex].Counties[countyindex].OtherDetails[otherindex][name] = ""
                updatedData[index].ProgramTypes[proIndex].Counties[countyindex].OtherDetails[otherindex]['RevenueCodeID'] = ""
            }
        }

        setFeeScheduleData(updatedData)


    }
    const handelChangeLocationDD = (e) => {
        setIs(false);
        setselectedLocation(e.target.value)
    }
    const handleSelectLocation = (selectedData) => {
        if (!isNull(selectedData)) {
            setselectedLocation(selectedData.display)
            setselectedLocationID(selectedData.value)
            let countylist = []
            // FeeScheduleData.map((item) => {
            //     if (item.LocationID === selectedData.value) {
            //         item.Counties && item.Counties.map((countyitem) => {
            //             let coumtyitem = { value: countyitem.FeeSetupCountyID, display: countyitem.County }
            //             countylist.push(coumtyitem)
            //         });
            //     }
            // })
            FeeScheduleData.map((item) => {
                if (item.LocationID === selectedData.value) {
                    item.ProgramTypes && item.ProgramTypes.map((proItem) => {
                        if (proItem.ProgramType === ProgramTypeId) {
                            proItem.Counties && proItem.Counties.map((countyitem) => {
                                let coumtyitem = { value: countyitem.FeeSetupCountyID, display: countyitem.County }
                                countylist.push(coumtyitem)
                            });
                        }
                    })

                }
            });
            setCountyDD(countylist)
            setselectedCounties([])
        }
    }
    const handleSelectedCounties = (selectedItems) => {
        setselectedCounties(selectedItems)
    }
    const handleSaveFeeSetup = () => {
        let BillingEntityValidation = false
        let StartDateValidation = false
        let EndDateValidation = false
        let saveState = []
        FeeScheduleData.map((item) => {
            item.ProgramTypes && item.ProgramTypes.map((proType) => {
                proType.Counties && proType.Counties.map((countyitem) => {
                    countyitem.OtherDetails && countyitem.OtherDetails.map((detailsitem) => {
                        console.log('detailsitem', detailsitem);
                        if (!isNull(detailsitem.Amount) && isNull(detailsitem.BillingEntity)) {
                            BillingEntityValidation = true
                        } else if (!isAmountNull(detailsitem.Amount) && isNull(detailsitem.StartDate)) {
                            StartDateValidation = true
                        } else if (isNull(detailsitem.StartDate) && !isNull(detailsitem.EndDate)) {
                            EndDateValidation = true
                        }
                        let saveDetailsitem = {
                            ProviderFeeScheduleID: !isNull(detailsitem.ProviderFeeScheduleID) ? detailsitem.ProviderFeeScheduleID : '0',
                            LocationID: detailsitem.locationid,
                            InsuranceID: InsuranceID,
                            ProcedureCode: detailsitem.ProcedureCode,
                            ProcedureCodeID: detailsitem.ProcedureCodeID,
                            Amount: detailsitem.Amount === "" ? '-99' : detailsitem.Amount,
                            AllowedAmount: detailsitem.AllowedAmount === "" ? '-99' : detailsitem.AllowedAmount,
                            StartDate: detailsitem.StartDate,
                            EndDate: detailsitem.EndDate,
                            FeeSetupCountyID: detailsitem.FeeSetupCountyID,
                            RevenueCode: detailsitem.RevenueCode,
                            RevenueCodeID: detailsitem.RevenueCodeID,
                            BillingEntity: detailsitem.BillingEntity,
                            DefaultUnits: detailsitem.DefaultUnits === "" ? '-99' : detailsitem.DefaultUnits,
                        };
                        saveState.push(saveDetailsitem)
                    });
                });
            })

        });

        if (BillingEntityValidation) {
            NotificationHandler('Billing Entity is required where amount is greater than zero!', enumUtil.enumtoaster.error)
        } else if (StartDateValidation) {
            NotificationHandler('Start Date is required where amount is greater than zero!', enumUtil.enumtoaster.error)
        } else if (EndDateValidation) {
            NotificationHandler('Start Date is required!', enumUtil.enumtoaster.error)
        } else {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveProviderFeeSchedule", 'post', {
                "TableName": enumUtil.enumAPITableName.AgencyProviderFeeSchedule,
                "Data": saveState
            }).then((response) => {
                setIsLoading(false)
                setfeeSetupid((Math.random()))
                fetchData('updated')
                NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
            }).catch((error) => {
                setIsLoading(false)
            })
        }
        // if (!BillingEntityValidation) {

        // } else {

        // }

    }
    // Program Type DD
    const [ProgramTypeDD, setProgramTypeDD] = useState([])
    const [ProgramTypeValue, setProgramTypeValue] = useState('')
    const [ProgramTypeId, setProgramTypeId] = useState('')


    const LoadProgrameTypeDD = (isUpdated) => {
        return ServerRequestProtected(API_URL + "/GetProgramType", 'post', {
            "TableName": enumUtil.enumAPITableName.FeeSetupCounty,
            "ID": InsuranceID + ""
        }).then((response) => {
            setProgramTypeDD(response)
            if (isUpdated !== 'updated') {
                if (response.length > 0) {
                    setProgramTypeValue(response[1].display)
                    setProgramTypeId(response[1].value)
                }
            }

            return response
        }).catch((error) => {
            setProgramTypeDD([])
            return []
        })
    }
    const handleProgramTypeChange = (e) => {
        setIs(false);
        setProgramTypeValue(e.target.value)
    }

    const handleSelectProgramType = (selectedData) => {
        if (!isNull(selectedData)) {
            let countylist = []
            let data = [...FeeScheduleData]
            data.map((item) => {
                if (item.LocationID === selectedLocationID) {
                    item.ProgramTypes && item.ProgramTypes.map((proItem) => {
                        if (proItem.ProgramType === selectedData.value) {
                            proItem.Counties && proItem.Counties.map((countyitem) => {
                                let coumtyitem = { value: countyitem.FeeSetupCountyID, display: countyitem.County }
                                countylist.push(coumtyitem)
                            });
                        }
                    })

                }
            });
            setCountyDD(countylist)
            setselectedCounties([])
            setProgramTypeValue(selectedData.display)
            setProgramTypeId(selectedData.value)
        } else {
            setProgramTypeValue('')
            setProgramTypeId()
        }
    }
    // add new county 
    const [isOpenCounty, setIsOpenCounty] = useState(false)
    const [countyID, setCountyID] = useState(0)
    const [EditCountyData, setEditCountyData] = useState([])
    const AddCounty = (data) => {
        if (!isNull(data)) {
            setEditCountyData([data])
            setCountyID(1)
            setIsOpenCounty(true)
        } else {
            setCountyID(0)
            setIsOpenCounty(true)
        }
    }
    const onCloseCounty = (reload) => {
        setIsOpenCounty(false)
        fetchData()
    }
    const [isOpenDelete, SetIsOpenDelete] = useState(false)
    const ConfirmDelete = (item) => {
        setEditCountyData([item])
        SetIsOpenDelete(true)
    }
    const CloseDelete = (reload) => {
        if (reload === 'reload') {
            fetchData()
        }
        SetIsOpenDelete(false)
    }
    const DeleteCounty = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL_General + "/DeleteSingleRecord", 'post', {
            "TableName": enumUtil.enumAPITableName.FeeSetupCounty,
            "DeleteData": {
                "InsuranceID": InsuranceID + "",
                "LocationID": selectedLocationID + "",
                "CountyName": EditCountyData[0].display,
            }
        }).then((response) => {
            setIsLoading(false)
            if (response === 'Deleted Successfully') {
                NotificationHandler('Deleted Successfully', enumUtil.enumtoaster.success)
                CloseDelete('reload')
            } else {
                NotificationHandler(response, enumUtil.enumtoaster.warning)
                CloseDelete()
            }
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            CloseDelete()
        })
    }
    let countyPopup = ''
    if (isOpenCounty) {
        let PT = ProgramTypeDD.filter(item => item.value !== '-1')
        countyPopup = <AddNewCounty isOpenCounty={isOpenCounty} onCloseCounty={onCloseCounty} LocationID={selectedLocationID} InsuranceID={InsuranceID}
            ProgramTypeDD={PT} selectedCounties={EditCountyData} countyID={countyID} />
    }
    // const FeeStructure = () => {
    //     // debugger
    //     return (

    //     )
    // }


    const handleSelectAll = () => {
        setSelectedFilter('All')
    }
    const handleChangeFilter = (e) => {
        setIs(false);
        setSelectedFilter(e.target.value)
    }
    const handleSelectFilter = (selectedData) => {
        setIs(true);
        if (!isNull(selectedData)) {
            setSelectedFilter(selectedData.value)
        } else {
            setSelectedFilter('All')
        }
    }
    return (
        <>
            {countyPopup}
            {isLoading ? <Loader /> : null}
            <div className='row m-0 mt-3 ar-fee_setup'>

                <div className="col-md-4 pe-0">
                    <div className="pb-2">
                        <p className="ar-light-color text text-nowrap validation_message">Insurance: <span className="heading fs-14 ar-dark-color" title={mainInsuranceModal.InsuranceName}>{mainInsuranceModal.InsuranceName}</span></p>
                    </div>
                    <div className="pb-1">
                        <div className='input form-group'>
                            <label htmlFor="LocationID">Location</label>
                            <SuperSearchList
                                type="client"
                                id='LocationID'
                                name='LocationID'
                                searchValue={selectedLocation}
                                // data={FeeScheduleData}
                                data={[
                                    { display: '', value: '' }, 
                                    ...(FeeScheduleData || [])
                                ]}
                                onChange={handelChangeLocationDD}
                                getSelectedData={handleSelectLocation}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                            />
                        </div>
                    </div>
                    <div className="pb-1">
                        <div className='input form-group'>
                            <label htmlFor="LocationID">Program Type</label>
                            <SuperSearchList
                                type="client"
                                id='ProgramType'
                                name='ProgramType'
                                searchValue={ProgramTypeValue}
                                data={ProgramTypeDD}
                                onChange={handleProgramTypeChange}
                                getSelectedData={handleSelectProgramType}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                            />
                        </div>
                    </div>
                    <div className="input form-group">
                        <label htmlFor="Locations" className="d-flex align-items-center text-nowrap">Select counties for {' '}<span className="font-m text-nowrap validation_message ms-1" title={selectedLocation}> {selectedLocation}</span>: <span className="ar_count ms-1 position-static px-1 text-white w-fit-content"> {selectedCounties.length} of {countyDD.length}</span></label>
                        <SearchList
                            key={countyDD}
                            ItemLists={countyDD}
                            type={"FeeSetup"}
                            Name={'Provider'}
                            // getProvider={props.getProvider}
                            handleSelectedProviders={handleSelectedCounties}
                            AddCounty={AddCounty}
                            ConfirmDelete={ConfirmDelete}
                        // view={view}
                        />
                    </div>
                    <p className="text red-text mt-1 fst-italic fs-10">Please select counties to update the rate</p>
                </div>
                {FeeScheduleData.length > 0 ?
                    <div className="col-md-8 pe-0">
                        <div className=" d-flex justify-content-between align-items-center select-bg-img-1 pb-1">
                            <p className="provider-header px-2 ar-dark-color heading w-fit-content">{selectedLocation}</p>
                            <div className="input">
                                {/* <select className="form-control fc-xs rounded" id='FeeSetupFilters' name='FeeSetupFilters' value={selectedFilter}
                                    onChange={(e) => setSelectedFilter(e.target.value)}>
                                    {FeeSetupFilters.map((e, index) => (
                                        <option value={e.value} key={index}>
                                            {e.display}
                                        </option>
                                    ))}
                                </select> */}
                                <SuperSearchList
                                    type="client"
                                    id='FeeSetupFilters'
                                    name='FeeSetupFilters'
                                    searchValue={selectedFilter}
                                    data={FeeSetupFilters}
                                    onChange={handleChangeFilter}
                                    getSelectedData={handleSelectFilter}
                                    is={is}
                                    // disableInput = {true}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                />
                            </div>
                        </div>
                        <div className="app-accordian">
                            {FeeScheduleData && FeeScheduleData.map((item, index) => {
                                let nfil = []
                                let all = false
                                if (selectedLocationID !== item.LocationID) return null
                                return (
                                    item.ProgramTypes && item.ProgramTypes.map((proType, proIndex) => {
                                        if (proType.ProgramType !== ProgramTypeId) return null
                                        return (proType.Counties.length > 0 && proType.Counties.filter(countiesItem =>
                                            selectedCounties.some(selected => selected.value === countiesItem.FeeSetupCountyID))
                                            .map((countiesItem, countiesIndex) => (
                                                <Accordion key={`accordion-${countiesIndex}`} defaultExpanded={true}>
                                                    <AccordionSummary
                                                        aria-hidden='true'
                                                        id={`prac1-header-${countiesIndex}`}
                                                        aria-controls={`prac1-content-${countiesIndex}`}
                                                        expandIcon={<ExpandMoreIcon />}
                                                        className="px-2"
                                                    >
                                                        <div className="d-flex align-items-center justify-content-between w-100 ">
                                                            <div className="d-flex align-items-center gap-1 mw-98">
                                                                <i className="icon-location-v1 fs-12">
                                                                    <i className="path1"></i>
                                                                    <i className="path2"></i>
                                                                    <i className="path3"></i>
                                                                </i>
                                                                <p className="heading text-nowrap validation_message w-100" title={countiesItem.County}> {countiesItem.County} </p>
                                                            </div>
                                                            <i className="icon-close fs-10"></i>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className="p-0">
                                                        <div className='fee-setup-table ad-expand-table'>
                                                            <table className='w-100'>
                                                                <thead>
                                                                    <tr>
                                                                        <th className='heading'>Code</th>
                                                                        {mainInsuranceModal?.PrimaryClaimType === "837 P" ? null : <th className='heading text-nowrap'> Rev. Code</th>}
                                                                        <th className='heading'>Amount</th>
                                                                        <th className='heading'>Allowed</th>
                                                                        <th className='heading'>Billing Entity</th>
                                                                        <th className='heading'>Def. Units</th>
                                                                        <th >
                                                                            <div className='d-flex justify-content-around align-items-center'>
                                                                                <p className='heading'>Start Date</p>
                                                                                <p className='heading'>End Date</p>
                                                                            </div>
                                                                        </th>

                                                                        <th className='heading'></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>

                                                                    {countiesItem.OtherDetails.length > 0 ? countiesItem.OtherDetails.map((otherItem, otherindex) => {
                                                                        nfil = countiesItem.OtherDetails.filter(item => item.Status === selectedFilter)
                                                                        all = selectedFilter === 'All'
                                                                        return otherItem.Status === selectedFilter ?
                                                                            <tr>
                                                                                <td className='text'>
                                                                                    {otherItem.ProcedureCode}
                                                                                </td>
                                                                                {mainInsuranceModal?.PrimaryClaimType === "837 P" ? null :
                                                                                    <td>
                                                                                        <SuperSearchList
                                                                                            width={'80px'}
                                                                                            type='server'
                                                                                            id='RevenueCode'
                                                                                            name='RevenueCode'
                                                                                            searchValue={otherItem.RevenueCode}
                                                                                            ApiLink={API_URL_General + "/InstantSearch"}
                                                                                            method='post'
                                                                                            postBody={RevCodeBody}
                                                                                            onChange={(e) => handleChangeOtherDetails(e, index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                            getSelectedData={(singlerow, name, type) => handleSelectRevenueCode(singlerow, name, type, index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                            is={is}
                                                                                            sup_btn='sup_btn-Inp'
                                                                                            sup_inp='superSearchVisitInp'
                                                                                            disabled={true}
                                                                                            placeholder={"Search..."}
                                                                                        />
                                                                                    </td>
                                                                                }
                                                                                <td>
                                                                                    <div className="input">
                                                                                        <input
                                                                                            type="text"
                                                                                            className='form-control amount'
                                                                                            id="Amount"
                                                                                            name='Amount'
                                                                                            autoComplete='off'
                                                                                            value={otherItem.Amount}
                                                                                            onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                            onChange={(e) => handleChangeOtherDetails(e, index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                        />
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <div className="input">
                                                                                        <input
                                                                                            type="text"
                                                                                            className='form-control amount'
                                                                                            id="AllowedAmount"
                                                                                            name='AllowedAmount'
                                                                                            autoComplete='off'
                                                                                            value={otherItem.AllowedAmount}
                                                                                            onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                            onChange={(e) => handleChangeOtherDetails(e, index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                        />
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <div className='input'>
                                                                                        <SuperSearchList
                                                                                            type="client"
                                                                                            id='BillingEntity'
                                                                                            name='BillingEntity'
                                                                                            searchValue={otherItem.BillingEntityDisplay}
                                                                                            data={billingEntityOption}
                                                                                            onChange={(e) => handleChangeOtherDetails(e, index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                            getSelectedData={(singlerow, name, type) => handleSelectRevenueCode(singlerow, name, type, index, proIndex, countiesIndex, otherItem.RecordID)}

                                                                                            is={is}
                                                                                            // disableInput = {true}
                                                                                            sup_btn='sup_btn-Inp'
                                                                                            sup_inp='superSearchVisitInp'
                                                                                        />
                                                                                        {/* <select
                                                                                            className='form-control'
                                                                                            name="BillingEntity"
                                                                                            id="BillingEntity"
                                                                                            value={otherItem.BillingEntityDisplay}
                                                                                            onChange={(e) => handleChangeOtherDetails(e, index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                        >
                                                                                            {billingEntityOption?.map((e, index) => (
                                                                                                <option value={e.value} key={index}>
                                                                                                    {e.display}
                                                                                                </option>
                                                                                            ))}
                                                                                        </select> */}
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <div className="input">
                                                                                        <input
                                                                                            type="text"
                                                                                            className='form-control'
                                                                                            id="DefaultUnits"
                                                                                            name='DefaultUnits'
                                                                                            value={otherItem.DefaultUnits}
                                                                                            autoComplete='off'
                                                                                            onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                            onChange={(e) => handleChangeOtherDetails(e, index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                            readOnly={otherItem.BillingEntity === '2' || otherItem.BillingEntity === 2 ? true : false}
                                                                                        // disabled={otherItem.BillingEntity === '2'}
                                                                                        />
                                                                                    </div>
                                                                                </td>
                                                                                <td className='text'>

                                                                                    <div className='d-flex align-items-center gap-2'>
                                                                                        <DatePicker
                                                                                            value={otherItem.StartDate}
                                                                                            handleCalendarChangefunc={date => handleCalendarChange(date, 'StartDate', index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                        />
                                                                                        <DatePicker
                                                                                            value={otherItem.EndDate}
                                                                                            handleCalendarChangefunc={date => handleCalendarChange(date, 'EndDate', index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                        />

                                                                                    </div>

                                                                                </td>

                                                                                <td className=''>
                                                                                    {!isNull(otherItem.StartDate) && !isNull(otherItem.EndDate) ?
                                                                                        <i className='icon-plus-feesetup fs-15' onClick={() => AddNewCountyRow(index, proIndex, countiesIndex, otherItem.RecordID)}> </i>
                                                                                        : null}
                                                                                </td>
                                                                            </tr>
                                                                            : selectedFilter === 'All' ?

                                                                                <tr>
                                                                                    <td className='text'>
                                                                                        {otherItem.ProcedureCode}
                                                                                    </td>
                                                                                    {mainInsuranceModal?.PrimaryClaimType === "837 P" ? null :
                                                                                        <td>
                                                                                            <SuperSearchList
                                                                                                width={'80px'}
                                                                                                type='server'
                                                                                                id='RevenueCode'
                                                                                                name='RevenueCode'
                                                                                                searchValue={otherItem.RevenueCode}
                                                                                                ApiLink={API_URL_General + "/InstantSearch"}
                                                                                                method='post'
                                                                                                postBody={RevCodeBody}
                                                                                                onChange={(e) => handleChangeOtherDetails(e, index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                                getSelectedData={(singlerow, name, type) => handleSelectRevenueCode(singlerow, name, type, index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                                is={is}
                                                                                                sup_btn='sup_btn-Inp'
                                                                                                sup_inp='superSearchVisitInp'
                                                                                                disabled={true}
                                                                                                placeholder={"Search..."}
                                                                                            />
                                                                                        </td>
                                                                                    }
                                                                                    <td>
                                                                                        <div className="input">
                                                                                            <input
                                                                                                type="text"
                                                                                                className='form-control amount'
                                                                                                id="Amount"
                                                                                                name='Amount'
                                                                                                autoComplete='off'
                                                                                                value={otherItem.Amount}
                                                                                                onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                                onChange={(e) => handleChangeOtherDetails(e, index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                            />
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div className="input">
                                                                                            <input
                                                                                                type="text"
                                                                                                className='form-control amount'
                                                                                                id="AllowedAmount"
                                                                                                name='AllowedAmount'
                                                                                                autoComplete='off'
                                                                                                value={otherItem.AllowedAmount}
                                                                                                onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                                onChange={(e) => handleChangeOtherDetails(e, index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                            />
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div className='input'>
                                                                                            <SuperSearchList
                                                                                                type="client"
                                                                                                id='BillingEntity'
                                                                                                name='BillingEntity'
                                                                                                searchValue={otherItem.BillingEntityDisplay}
                                                                                                data={billingEntityOption}
                                                                                                onChange={(e) => handleChangeOtherDetails(e, index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                                getSelectedData={(singlerow, name, type) => handleSelectRevenueCode(singlerow, name, type, index, proIndex, countiesIndex, otherItem.RecordID)}

                                                                                                is={is}
                                                                                                // disableInput = {true}
                                                                                                sup_btn='sup_btn-Inp'
                                                                                                sup_inp='superSearchVisitInp'
                                                                                            />
                                                                                            {/* <select
                                                                                                className='form-control'
                                                                                                name="BillingEntity"
                                                                                                id="BillingEntity"
                                                                                                value={otherItem.BillingEntity}
                                                                                                onChange={(e) => handleChangeOtherDetails(e, index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                            >
                                                                                                {billingEntityOption?.map((e, index) => (
                                                                                                    <option value={e.value} key={index}>
                                                                                                        {e.display}
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select> */}
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div className="input">
                                                                                            <input
                                                                                                type="text"
                                                                                                className='form-control'
                                                                                                id="DefaultUnits"
                                                                                                name='DefaultUnits'
                                                                                                value={otherItem.DefaultUnits}
                                                                                                onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                                onChange={(e) => handleChangeOtherDetails(e, index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                                readOnly={otherItem.BillingEntity === '2' || otherItem.BillingEntity === 2 ? true : false}
                                                                                            />
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className='text'>

                                                                                        <div className='d-flex align-items-center gap-2'>
                                                                                            <DatePicker
                                                                                                value={otherItem.StartDate}
                                                                                                handleCalendarChangefunc={date => handleCalendarChange(date, 'StartDate', index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                            />
                                                                                            <DatePicker
                                                                                                value={otherItem.EndDate}
                                                                                                handleCalendarChangefunc={date => handleCalendarChange(date, 'EndDate', index, proIndex, countiesIndex, otherItem.RecordID)}
                                                                                            />

                                                                                        </div>

                                                                                    </td>
                                                                                    <td className=''>
                                                                                        {!isNull(otherItem.StartDate) && !isNull(otherItem.EndDate) ?
                                                                                            <i className='icon-plus-feesetup fs-15' onClick={() => AddNewCountyRow(index, proIndex, countiesIndex, otherItem.RecordID)}> </i>
                                                                                            : null}
                                                                                    </td>
                                                                                </tr>
                                                                                : null
                                                                    }) : null}

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        {/* Need to add a message in county when feeschedule is not added */}
                                                        {selectedFilter === 'Active' && nfil.length === 0 ?
                                                            <div className="d-flex justify-content-center">
                                                                <div className='feeschedule-empty'>
                                                                    <p className='Hold-clr text fst-italic'>Fee schedule is not added yet. <span className='za-blue-clr fontt-m cursor-pointer' onClick={() => handleSelectAll()}>Click here</span> to see all codes.</p>
                                                                </div>
                                                            </div>
                                                            : null}
                                                    </AccordionDetails>
                                                </Accordion>
                                            ))
                                        )
                                    })
                                )
                            }
                            )}

                            {/* {FeeScheduleData && FeeScheduleData.map((item, index) => {
                                if (item.LocationID === selectedLocationID) {
                                    return item.ProgramTypes && item.ProgramTypes.map((proType, proIndex) => {
                                        if (proType.ProgramType === ProgramTypeValue) {
                                            return <h1 key={`${index}-${proIndex}`}>{proType.ProgramType}</h1>;
                                        }
                                        return null; // Return null if the condition is not met
                                    });
                                }
                                return null; // Return null if LocationID does not match
                            })} */}

                        </div>
                    </div>

                    : null
                }
            </div>
            <ModalFooter isSaved={onClose} handleSave={handleSaveFeeSetup} UpdatedDate={mainInsuranceModal.UpdatedDate} UpdatedBy={mainInsuranceModal.UpdatedBy} ID={''} IsEditAllowed={IsEditAllowed} />


            {/* Delete County */}

            <Modal show={isOpenDelete} onHide={CloseDelete} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 ar_delte_modal">
                {isLoading ? <Loader /> : null}
                <ModalBody>
                    <div className='d-flex justify-content-between delete-header align-items-center p-0 mb-12'>
                        <p className="heading">Delete Action?</p>
                        <i className='icon-Icon-metro-cross' onClick={CloseDelete}></i>
                    </div>
                    <div className='undo-body p-0'>
                        {
                            props.Messsage ?
                                <div className='ar-alert d-flex'>
                                    <i className='icon-alert mt-1'></i>
                                    <div>
                                        <p className='text ms-1'>This action cannot be undone. All values
                                            associated with this will be lost.</p>
                                    </div>
                                </div>
                                : null
                        }
                        <div className="input">
                            <label className='heading'>Reason</label>
                            <textarea rows="3" className='form-control'></textarea>
                        </div>
                    </div>
                </ModalBody>
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={CloseDelete} >Cancel</button>
                    <button className='btn btn-danger px-10 h-100' onClick={DeleteCounty}>Delete</button>
                </div>
            </Modal>

        </>

    )
}

export default FeeSetup